<script setup>
	import { computed } from 'vue';
	import { useStore } from 'vuex';
	import { DsButton, dsUseIsMobile } from '@coloplast/design-system';
	import { clearQueryStringParameters } from 'shared/services/windowLocationService';

	const store = useStore();
	const returnButtonText = computed(() => store.getters['getReturnButtonText']);

	const { isMobile } = dsUseIsMobile();

	const showStartTool = () => {
		clearQueryStringParameters(window.location.href);
		window.location.reload();
	};
</script>

<template>
	<Teleport
	  to="[data-teleport-result]"
	  :disabled="isMobile"
  	>
		<div class="c-fit-tool__result">
			<DsButton
				v-if="!isMobile"
				icon-start="navigate-back"
				size="md"
				variant="link"
				:disabled="null"
				class="c-fit-tool__result-button"
				:click-handler="showStartTool"
		  	>
				{{ returnButtonText }}
			</DsButton>
			<slot name="introduction"></slot>
		</div>
	</Teleport>
	<slot></slot>
</template>
